module.exports = __webpack_public_path__ + "img/xp_icon_sj01.png";